<template>
  <IQOS :systemDependency="'delivery'" required :title="$t('delivery.geo.title')">  
    <div
      :class="{
        'google-map-container': true,
        'mt-16': true
      }"
    >
      <GoogleMapDisplay
        :lat="zone_index == -1 ? zone_start_pos.lat : zones[zone_index].lat"
        :lon="zone_index == -1 ? zone_start_pos.lon : zones[zone_index].lon"
        :radius="0"
        :locked="false"
        :show_zones="zone_index == -1"
        :zones="zones"
        @pin="onMapPin"
        ref="googleMap"
      />
    </div>

    <div class="geo-zones mt-16">
      <template v-for="(zone, index) in zones" >
        <div class="geo-single-zone mb-16" :key="index">
          <!-- <BaseButton variant="primary" color="v1-grey-4" size="md">
            {{ index + 1 }}
          </BaseButton> -->
          <BaseInput @blur="onZoneNameChanged" fullWidth :placeholder="`${$t('delivery.geo.zone')} ${index+1}`" v-model="zone.name"/>
          <BaseUnitInput
            class="zone-radius w-100 ml-8"
            fullWidth
            type="number"
            :value="toKm(zone.radius)"
            @input="(v) => setZoneRadius(index, v)"
            @blur="onEditFinish"
            :placeholder="$t('delivery.geo.radius')"
            :readonly="false"
            :unitPlaceholder="'km'"
          />
          <BaseUnitInput
            class="zone-radius w-100 ml-8"
            fullWidth
            type="number"
            v-model.number="zones[index].price"
            @blur="onEditFinish"
            :placeholder="$t('delivery.price.title')"
            :readonly="false"
            :unitPlaceholder="currency.symbol"
            v-if="isDeliveryPaid"
          />
          <BaseButton 
            icon="trash" 
            size="md" 
            variant="secondary" 
            color="red-4" 
            @click="onZoneRemove(index)"
            class="ml-8"/>
        </div>
        <BaseDivider color="v1-grey-4" class="mb-8" :key="'divider'+index"/>
      </template>
    </div>

    <p class="iqos-comment qrw-paragraph-md mt-16" v-if="adding_new_zone">
      {{ $t("delivery.geo.click_to_add") }}
    </p>

    <BaseButton 
      @click="adding_new_zone = true"
      v-if="!adding_new_zone" 
      size="md" 
      class="w-100"
      variant="secondary"
      color="v1-grey-10"
      icon="plus"> 
      {{ $t('delivery.geo.add_zone') }}
    </BaseButton>

    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("delivery.geo.desc") }}
    </p>

    

    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("delivery.geo.explain") }}
    </p>
  </IQOS>
</template>

<script>
import GoogleMapDisplay from "@/components/GoogleMapDisplay.vue";

export default {
  data() {
    return {
      geo: {
        lat: 48.622279,
        lon: 22.298535,
        radius: 0,
      },
      zones: [],
      zone_index: -1,
      editing: false,
      zone_start_pos: {
        lat: 48.622279,
        lon: 22.298535,
      },
      adding_new_zone: false
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
      this.zone_index = -1;

      this.geocodeAddress();
    },
    hideEditUI() {
      this.editing = false;
      this.setInitialGeo();
    },
    onEditFinish() {
      this.$store.commit("setDeliveryGeolocationZones", this.zones);
      this.$store.dispatch("saveCafe");
      this.editing = false;
      this.zone_index = -1;
    },
    onMapPosChange(lat, lon) {
      this.zones[this.zone_index].lat = lat;
      this.zones[this.zone_index].lon = lon;
    },
    setInitialGeo() {
      if (
        this.cafe.delivery.geolocation &&
        this.cafe.delivery.geolocation.lat
      ) {
        this.geo.lat = this.cafe.delivery.geolocation.lat;
        this.geo.lon = this.cafe.delivery.geolocation.lon;
        this.geo.radius = this.cafe.delivery.geolocation.radius;
      }
    },
    loadInitialZones() {
      if (this.cafe.delivery && this.cafe.delivery.geolocations) {
        this.zones = this.cafe.delivery.geolocations.slice();
      }
    },
    addZone() {
      this.zones.push({
        lat: this.zone_start_pos.lat,
        lon: this.zone_start_pos.lon,
        radius: null,
        price: null
      });

      if (this.zone_index == -1) {
        this.zone_index = this.zones.length - 1;
      }
    },
    onZoneEdit(index) {
      this.zone_index = index;
    },
    onZoneRemove(index) {
      this.zones.splice(index, 1);

      if (this.zone_index >= this.zones.length) {
        this.zone_index = this.zones.length - 1;
      }

      this.onEditFinish();
    },
    onMapPin(pos) {
      if (!this.adding_new_zone) return;

      this.adding_new_zone = false;

      this.zones.push({
        lat: this.zone_start_pos.lat,
        lon: this.zone_start_pos.lon,
        radius: null,
      });

      if (this.zone_index == -1) {
        this.zone_index = this.zones.length - 1;
      }

      this.zones[this.zone_index].lat = pos.lat;
      this.zones[this.zone_index].lon = pos.lon;

      this.zone_index = -1;
    },
    toKm(m) {
      if (!m) return null;
      return Math.round((m / 1000) * 100) / 100;
    },
    setZoneRadius(index, value) {
      const num = parseFloat(value);

      if (!isNaN(num)) {
        this.zones[index].radius = num * 1000;
      }

      this.$refs.googleMap.rerender();
    },
    onZoneNameChanged() {
      this.$refs.googleMap.rerender();

      this.onEditFinish();
    },
    geocodeAddress() {
      // const geocoder = new window.google.maps.Geocoder();
      // geocoder.geocode(
      //   {
      //     address: this.cafe.address
      //   },
      //   (results, status) => {
      //     if (status == window.google.maps.GeocoderStatus.OK) {
      //       const start_pos = results[0].geometry.location;

      //       this.zone_start_pos.lat = start_pos.lat();
      //       this.zone_start_pos.lon = start_pos.lng();
      //     }
      //   }
      // );
      if (this.cafe.address_location) {
        this.zone_start_pos.lat = this.cafe.address_location.lat;
        this.zone_start_pos.lon = this.cafe.address_location.lon;
      }
    },
  },
  created() {
    // this.setInitialGeo();
    this.geocodeAddress();
    this.loadInitialZones();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    kmRadius: {
      get() {
        return Math.round((this.geo.radius / 1000) * 10) / 10;
      },
      set(v) {
        this.geo.radius = v * 1000;
      },
    },
    isDeliveryPaid() {
      return this.cafe.delivery.cost_type == 'constant' || this.cafe.delivery.cost_type == 'conditional'; 
    },
    currency() {
      return this.$store.state.currency;
    }
  },
  components: {
    GoogleMapDisplay,
  },
};
</script>

<style scoped>
.geo-single-zone {
  display: flex;
  width: 100%;
}
</style>